var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCosmosSdkSmallWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cosmos SDK"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.6077 6.57784L12 1.15519L21.3923 6.57784V17.4231L12 22.8458L2.6077 17.4231V6.57784Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.71484 12.9435V11.0533L7.35188 10.1081L8.98892 11.0533V12.9435L7.35188 13.8887L5.71484 12.9435Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.3633 12.9435V11.0533L12.0003 10.1081L13.6374 11.0533V12.9435L12.0003 13.8887L10.3633 12.9435Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.0117 12.9435V11.0533L16.6488 10.1081L18.2858 11.0533V12.9435L16.6488 13.8887L15.0117 12.9435Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.03516 8.93036V7.04007L9.67219 6.09493L11.3092 7.04007V8.93036L9.67219 9.8755L8.03516 8.93036Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12.6875 8.93036V7.04007L14.3245 6.09493L15.9616 7.04007V8.93036L14.3245 9.8755L12.6875 8.93036Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M8.03516 16.9616V15.0713L9.67219 14.1262L11.3092 15.0713V16.9616L9.67219 17.9068L8.03516 16.9616Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M12.6875 16.9616V15.0713L14.3245 14.1262L15.9616 15.0713V16.9616L14.3245 17.9068L12.6875 16.9616Z",
    stroke: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCosmosSdkSmallWhite);
export default __webpack_public_path__ + "static/media/cosmosSDKSmallWhite.04c5eabc.svg";
export { ForwardRef as ReactComponent };